import React, {useState} from "react";
import {MultiSelect} from "primereact/multiselect";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {sortAlphabetically} from "../../../../api/utils/sortArrays";
import {showWarn} from "../../../../api/notification/ToastManager";
import {Chip} from "primereact/chip";

export default function MultiSelectWithAdd(props) {
    const [newItem, setNewItem] = useState("");

    const truncate = (text, max) =>
        text.length > max ? text.slice(0, max) + "..." : text;

    const addItem = () => {
        const exists = props.options.some(
            (option) => option.name === newItem
        );
        if (exists) {
            showWarn("Tag Exists", "The tag with label " + newItem + " already exists.");
        } else {
            props.addItem(newItem);
            setNewItem("");
        }
    };

    const handleChange = (event) => {
        props.onChange(event);
    };

    const removeTag = (tagToRemove) => {
        const newTags = props.selectedTags.filter(
            (tag) => tag.name !== tagToRemove.name
        );
        props.onChange({target: {value: newTags, name: props.name}});
    };

    const groupItems = () => {
        const groupedItems = [];
        if (props.options.some((item) => item.defaultTag)) {
            groupedItems.push({
                label: "Default Tags",
                items: props.options.filter((item) => item.defaultTag),
            });
        }
        if (props.options.some((item) => !item.defaultTag)) {
            groupedItems.push({
                label: "Free Tags",
                items: props.options.filter((item) => !item.defaultTag),
            });
        }
        return groupedItems;
    };

    const updateItem = (e) => {
        if (e?.target?.value === "" || e?.target?.value?.match(/^[-_a-zA-Z0-9 ]+$/) !== null) {
            setNewItem(e.target.value)
        }
    }


    return (
        <div className="p-1 gap-2 w-full">
            <div className="flex gap-3 pb-3 w-full">
                <InputText
                    value={newItem}
                    onChange={(e) => updateItem(e)}
                    placeholder="Add new tag"
                    className="flex-1"
                />
                <Button
                    onClick={addItem}
                    disabled={!newItem.trim()}
                    style={{backgroundColor: "#487c84", width: "110px"}}
                    label="Add tag"
                    type="button"
                />
            </div>

            <MultiSelect
                name={props.name}
                value={props.selectedTags}
                options={sortAlphabetically(groupItems(props.options), "name")}
                optionLabel={props.optionLabel}
                onChange={(e) => handleChange(e)}
                placeholder={props.placeholder}
                panelStyle={{width: "200px"}}
                optionGroupLabel="label"
                optionGroupChildren="items"
                className="w-full"
                filter
                fixedPlaceholder={true}
            />

            {props.selectedTags?.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                    {props.selectedTags.map((tag) => (
                        <Chip
                            key={tag.id}
                            label={truncate(tag.name, 10)}
                            onRemove={() => removeTag(tag)}
                            className={"mb-2"} removable/>
                    ))}
                </div>
            )}
        </div>
    );
}
